import { Dispatch, createContext } from 'react';
import { Action, PageAnimation } from '../types/types';

export const AnimationContext = createContext<PageAnimation>( { direction: 1 } );

export const AnimationDispatchContext = createContext<Dispatch<
	Action & PageAnimation
> | null>( null );
